export enum ModalType {
    ChangePassword,
    ShowDashboard,
    ShowDashboardOperative
  }
